import {Radio} from 'antd'
import {course_getStudents_Api} from 'apis'
import {getId} from 'apis/model/base'
import EmptyHolder from 'components/EmptyHolder'
import {createValue} from 'components/form/utils'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncWithCache from 'modules/asyncCache/useAsyncWithCache'
import React, {useMemo} from 'react'
import ContainerPicker, {renderDefaultActions} from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {getResponseItems, renderIf} from 'views/Shared'
import {BiSolidEnvelope, BiSolidPhoneCall} from "react-icons/bi";
import LoadingBlock from "../../../LoadingBlock";

export const StudentPicker = ({
                                  name,
                                  value,
                                  onChange,
                                  owner_id,
                                  owner_type,
                                  field_names = [],
                                  ...props
                              }) => {
    const defaultValue = getId(value) ?? value
    return renderIf(
        owner_id && owner_type,
        <ContainerPicker
            name={name}
            allowClear={true}
            label="choose students"
            defaultValue={defaultValue}
            type={AppEntities.UNDEFINED}
            renderActions={renderDefaultActions(value)}
            onOptionChange={(option) => {
                const value = option ? _.pick(option, field_names) : null
                onChange(createValue(name, value))
            }}
            customConfigs={{
                apiInfo: course_getStudents_Api,
                query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
            }}
            {...props}
        />
    )
}

export const CourseStudentList = ({
                                      name,
                                      value,
                                      onChange,
                                      owner_id,
                                      owner_type,
                                      information,
                                      field_names = [],
                                      ...props
                                  }) => {
    const apiInfo = course_getStudents_Api;

    const cacheId = useMemo(
        () =>
            [
                apiInfo?.path?.replace(':id', owner_id)?.replace(':type', owner_type),
                `email=${information?.contact_email}`,
                `identifier_code=${information?.identifier_code}`,
                `student_idcode=${information?.student_idcode}`,
            ].join('?'),
        [owner_id, owner_type, information]
    )

    const {response, isLoading = false} = useAsyncWithCache({
        cacheId,
        apiInfo,
        query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
        values: {
            email: information?.contact_email,
            identifier_code: information?.identifier_code,
            student_idcode: information?.student_idcode,
        },
    })

    const items = getResponseItems(response)

    const options = Array.from(items ?? [])

    if (isLoading) {
        return <LoadingBlock/>
    }

    if (options.length <= 0) {
        return <EmptyHolder/>
    }

    return (
        renderIf(
            options.length > 0,
            <Radio.Group
                name={name}
                buttonStyle="solid"
                optionType="default"
                className="grid grid-cols-1 md:grid-cols-2 gap-x-1 gap-y-3 custom-radio-group"
                defaultValue={getId(value) ?? value}
                onChange={(event) => {
                    const selected_id = event?.target?.value
                    const option = _.find(options, (e) => getId(e) === selected_id)
                    const value = option ? _.pick(option, field_names) : null
                    onChange(createValue(name, value))
                }}>
                {options.map((option, index) => (
                    <Radio.Button key={index} value={getId(option)}>
                        <div style={{padding: '4px 10px'}} className="radio-select-items rounded-md">
                          <span className="font-bold text-sm leading-snug">
                              {getTitle(option)}
                          </span>
                            <div className="flex items-center gap-4">
                                {renderIf(
                                    _.get(option, 'contact_phone'),
                                    <span className="flex items-center gap-1 leading-tight">
                                    <BiSolidPhoneCall size={12} className="text-color-500"/>
                                    <span style={{fontSize: 11}}
                                          className="font-medium text-color-100 italic tracking-wide">
                                        {_.get(option, 'contact_phone')}
                                    </span>
                                  </span>
                                )}
                                {renderIf(
                                    _.get(option, 'contact_email'),
                                    <span className="flex items-center gap-1 leading-tight truncate">
                                    <BiSolidEnvelope size={12} className="text-color-500"/>
                                    <span style={{fontSize: 11}}
                                          className="font-medium text-color-100 italic tracking-wide">
                                      {_.get(option, 'contact_email')}
                                    </span>
                                  </span>
                                )}
                            </div>
                        </div>
                    </Radio.Button>
                ))}
            </Radio.Group>
        )
    )
}
